import React, { useState, useEffect } from 'react';
import OnboardingStepsStack from './OnboardingStepsStack'
import WorkSpaceStack from './WorkSpaceStack';
import { useMsal, useIsAuthenticated, useMsalAuthentication } from '@azure/msal-react';
import { InteractionRequiredAuthError, InteractionStatus, InteractionType } from "@azure/msal-browser";
import { msalInstance } from '..';
import { useDispatch, useSelector } from 'react-redux';
import { setCookieId, setUserName, setAccessToken, setRedirectUrl, setSessionId, setPartnerName, setTokenExpiresOn } from '../features/onboardingData/onboardingUserData';
import { useNavigate, useLocation } from 'react-router-dom';
import { removeSecureData } from '../utils/secureStorage';
import { toast } from "react-toastify";

const RoutesStack = () => {
  
  const isAuthenticated = useIsAuthenticated();
  const activeAccount = msalInstance.getActiveAccount();
  let location = useLocation();
  
  const { instance, inProgress, accounts } = useMsal();
  // const [tokenExpiresOn, setTokenExpiresOn] = useState(null);
  const [responseRefreshAccessToken, setResponseRefreshAccessToken] = useState(null);
  const isCookieId = useSelector((state) => state.onboardingUserData.isCookieId);
  const isUserName = useSelector((state) => state.onboardingUserData.isUserName);
  const isAccessToken = useSelector((state) => state.onboardingUserData.isAccessToken);
  const isTokenExpiresOn = useSelector((state) => state.onboardingUserData.isTokenExpiresOn);
  const isRedirectUrl = useSelector((state) => state.onboardingUserData.isRedirectUrl);
  const isSessionId = useSelector((state) => state.onboardingUserData.isSessionId);
  const isPartnerName = useSelector((state) => state.onboardingUserData.isPartnerName);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
        localStorage.clear();
        toast.dismiss();
        const response = await instance.logout();
    } 
    catch (error) {
      localStorage.clear();
    }
  };

  const redirectURL = () => {    
    if (isRedirectUrl !== '') {
      navigate(`${isRedirectUrl}`);
      //window.location.href =`${isRedirectUrl}`;
      dispatch(setRedirectUrl(''));
      removeSecureData('isRedirectUrl');
    }
  }

  const getRedirectParceirostURL = () => {
    const fullURL = window.location.href;
    const pathSegments = new URL(fullURL).pathname.split('/');
    const pathSegmentsHome = new URL(fullURL).pathname.split('/');

    const index = pathSegments.indexOf('catalogo-de-parceiros');
    const indexHome = pathSegmentsHome.indexOf('carteira-virtual');

    if (indexHome !== -1) {
      const extractedPath = pathSegmentsHome.slice(indexHome + 1).join('/'); 
      const navUrlDecoded = decodeURIComponent(`/${extractedPath}`);
      dispatch(setRedirectUrl(navUrlDecoded))
    }

    if (index !== -1 && pathSegments[index + 1]) {
      const categoryStore = pathSegments[index + 1]; 
      const categoryStoreReplace = categoryStore.replace(/%20/g, ' ');
      const categoryStoreDecoded = decodeURIComponent(categoryStore);
      dispatch(setPartnerName(categoryStoreDecoded));
    }
  }

  const redirecParceirostURL = (store) => {
    const category = store.toLowerCase();
    const seacrhCategory = category;
    navigate(`/ganhar-saldo/parceiros/catalogo-de-parceiros/`, { state: {seacrhCategory} });
    dispatch(setRedirectUrl(''));
    removeSecureData('isRedirectUrl');
    dispatch(setPartnerName(''));
    removeSecureData('isPartnerName');
  };

  useEffect(() => {
    if (isPartnerName === '') {
      getRedirectParceirostURL();
    }
  }, []); 

  useEffect(() => {
    if (!isAuthenticated && isPartnerName === '') {
      getRedirectParceirostURL();
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated && isRedirectUrl !== '' && isCookieId !== '') {
        if (isPartnerName !== '') {
          redirecParceirostURL(isPartnerName); 
        }
        if ( isRedirectUrl !== '' && isPartnerName === '') {
          redirectURL();
        }
    }
  }, [isAuthenticated, instance, accounts, inProgress, isPartnerName, isRedirectUrl, isCookieId])

  const accessTokenRequest = () => {
    if (inProgress === InteractionStatus.None) {
      const accessTokenRequest = {
        scopes: ['openid', 'profile', 'offline_access', process.env.REACT_APP_CLIENT_ID],
        account: accounts[0],
      };
      instance
        .acquireTokenSilent(accessTokenRequest)
        .then((accessTokenResponse) => {
          // Acquire token silent success
          let accessToken = accessTokenResponse.accessToken;
          let oid = accessTokenResponse.account.idTokenClaims.oid;
          let name = accessTokenResponse.account.idTokenClaims.given_name;
          let surname = accessTokenResponse.account.idTokenClaims.family_name;
          let expToken = accessTokenResponse.account.idTokenClaims.exp;
          const surnameParts = surname.split(' ');
          const lastSurname = surnameParts[surnameParts.length - 1];
          dispatch(setCookieId(oid))
          dispatch(setAccessToken(accessToken));
          dispatch(setTokenExpiresOn(Number(expToken)));
          const userName = `${name.charAt(0)}${lastSurname.charAt(0)}`;
          dispatch(setUserName(userName));
        })
        .catch((error) => {
          if (error instanceof InteractionRequiredAuthError) {
            const loginRequest = {
              scopes: ["openid"],
            };
            msalInstance.loginRedirect(loginRequest);
          }
          handleLogout();
        });
    }
  }

  useEffect(() => {
    accessTokenRequest()
  }, [instance, accounts, inProgress, location.pathname]);
  
  const refreshToken = async () => {
    try {
      const account = msalInstance.getActiveAccount();
      if (!account) {
        handleLogout();
      }

      const refreshTokenRequest = {
          scopes: ['openid', 'profile', 'offline_access', process.env.REACT_APP_CLIENT_ID],
          account: account,
          forceRefresh: true,
          refreshTokenExpirationOffsetSeconds: 7200
      };

      const tokenResponse = await msalInstance.acquireTokenSilent(refreshTokenRequest);
      setResponseRefreshAccessToken(tokenResponse.accessToken);

      let accessToken = tokenResponse.accessToken;
      let oid = tokenResponse.account.idTokenClaims.oid;
      let name = tokenResponse.account.idTokenClaims.given_name;
      let surname = tokenResponse.account.idTokenClaims.family_name;
      let expToken = tokenResponse.account.idTokenClaims.exp;
      const surnameParts = surname.split(' ');
      const lastSurname = surnameParts[surnameParts.length - 1];
      dispatch(setCookieId(oid))
      dispatch(setAccessToken(accessToken));
      dispatch(setTokenExpiresOn(Number(expToken)));
      const userName = `${name.charAt(0)}${lastSurname.charAt(0)}`;
      dispatch(setUserName(userName));

      return responseRefreshAccessToken;

    } catch (error) {
      handleLogout();
    }
  };

  useEffect(() => {
    const calculateRefreshTime = () => {
      if (!isTokenExpiresOn) return;

      const expirationTimeMs = isTokenExpiresOn * 1000;
      const currentTime = Date.now();
      const refreshTime = expirationTimeMs - currentTime - 10 * 60 * 1000;

      if (refreshTime > 0) {
        
        const timeout = setTimeout(() => {
          if (activeAccount) {
            refreshToken();
          } else {
            handleLogout();
          }
        }, refreshTime);

        return () => clearTimeout(timeout); 
      } else {
        handleLogout();
      }
    };

    return calculateRefreshTime();
  }, [isTokenExpiresOn, activeAccount, instance, accounts, inProgress, location.pathname]);

  useEffect(() => {
   
    if (process.env.REACT_APP_CONSOLE_LOG !== "N"){
      console.log("AccessToken: " + isAccessToken);
      console.log("isCookieId: " + isCookieId);
      console.log("tokenExpiresOn: " + isTokenExpiresOn);
      console.log("isRedirectUrl ", isRedirectUrl);
      console.log("activeAccount ", activeAccount);
    }
  }, [isAccessToken])

  return (
    <>
      { isAuthenticated ? (
        <WorkSpaceStack />
      ) : (
        <OnboardingStepsStack />
      )}
    </>
  );
};

export default RoutesStack;
